// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__222UB","inputWrap":"styles_inputWrap__3K4iA","input":"styles_input__HS2p8"};